define('modules/form_editor/views/preview_custom_date_amp',['require','exports','module','./preview_base','lib/util','ldsh!../templates/preview_custom_date_amp'],function(require, exports, module){
  "use strict";
  var PreviewBase = require("./preview_base"),
    util = require('lib/util');

  module.exports = PreviewBase.extend({
    template: require("ldsh!../templates/preview_custom_date_amp"),
    className: "form-group ed-panel-item form-group-col date-group",

    onRender: function() {
      module.exports.__super__.onRender.apply(this, arguments);
      this.$el.i18n();
    },

    helpers: function () {
      return {
        AMPComponentId: util.generateRandom() + '_customDate',
        inputFieldId: util.generateRandom() + '_customDate',
        ageLimit: this.getAgeLimit(),
        min: '1900-01-01',
        format: 'YYYY-MM-DD'
      };
    },

    getAgeLimit: function () {
      return this.model.get('ageLimit');
    }
  });
});

